<div class="modal">
  <div class="modal-content border-t border-t-gray-200 {{animationState}} {{data.klass || ''}}"
       [ngStyle]="{width: data.width ? data.width : '', height: data.height ? data.height : '', 'min-height': data.minHeight ? data.minHeight : ''}">
    <div class="max-w-[500px] mx-auto w-full overflow-hidden flex flex-col flex-auto items-start">
      <ng-template #dynamicComponentContainer></ng-template>
    </div>
  </div>
</div>
